import {
    Component,
    OnInit,
    OnDestroy,
    HostBinding,
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as LinkFileListActions from '../../actions/link-file-list.actions';
import { Subscription } from 'rxjs';
import { TransferService } from '../../transfer/transfer.service';
import { NgbDropdownConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogLinkZipComponent } from '../dialog-link-zip/dialog-link-zip.component';
import { ThumbnailsService } from '../../file-list/services/thumbnails.service';
import { BrowserSupportService } from '../../core/browser-support.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { LoggerService } from '../../core/logger.service';
import { BuildTransferItemService } from '../../transfer/services/build-transfer-item.service';
import { FileItemService } from '../../file/file-item.service';
import { UploadFolderService } from '../../transfer/upload-folder.service';
import { canBrowserOpen, getFileExt } from '../../shared/func';
import { ActivatedRoute, Router } from '@angular/router';
import { RunUploadFolderService } from 'src/app/transfer/services/run-upload-folder.service';
import { BlendEvent } from '../../shared/models';
import { BlendService } from '../../shared/services/blend.service';

@Component({
    selector: 'sync-link-file-list',
    templateUrl: './link-file-list.component.html',
})
export class LinkFileListComponent implements OnInit, OnDestroy {
    public cwd: sync.IFile;
    public list: sync.IFile[] = [];

    public upload: number;
    public canSave: boolean;
    public previewonly: 0 | 1;
    public compat = 0;
    public initialized: boolean;
    public isRoot: boolean;

    //white label attributes
    public isWhiteLabel: boolean;
    public linkTextColor: String;

    public allowComment: 0 | 1 | 2;

    private isBusiness: 0 | 1;
    private PAGE_TITLE = 'Sync.com';

    public UPLOAD_NON_VISIBLE = 2;
    public UPLOAD_VISIBLE = 1;
    public UPLOAD_DISABLED = 0;
    public isTransfering: boolean;

    public paginate: sync.IPaginate = {
        total: 0,
        currentPage: 1,
        itemsPerPage: 50,
        numPages: 0,
        viewOffset: 0,
        viewEnd: 0,
    };
    private sub: Subscription;
    private key: string;
    private passlock: string;
    public folderTransferView: sync.IUploadFolderView;
    private prevRouterState: any;

    constructor(
        private browserSupport: BrowserSupportService,
        private modalService: NgbModal,
        private store: Store<fromRoot.State>,
        private thumbs: ThumbnailsService,
        private sanitizer: DomSanitizer,
        private pageTitleService: Title,
        private log: LoggerService,
        private transferService: TransferService,
        private uploadFolderService: UploadFolderService,
        private buildTransferItemService: BuildTransferItemService,
        private fileItemService: FileItemService,
        private route: ActivatedRoute,
        private router: Router,
        private runUploadFolderService: RunUploadFolderService,
        config: NgbDropdownConfig,
        private blendService: BlendService
    ) {
        config.placement = 'left-top';
    }

    ngOnInit() {
        this.prevRouterState = this.router.routeReuseStrategy.shouldReuseRoute;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.folderTransferView = this.runUploadFolderService.view;
        this.sub = this.store
            .select(fromRoot.getLinkFileListState)
            .subscribe((data) => {
                this.previewonly = data.previewonly;
                this.upload = data.upload;
                this.key = data.linkkey;
                this.compat = data.compat;
                this.isRoot = data.is_root;
                this.isBusiness = data.is_business;

                if (data.cwd) {
                    this.cwd = data.cwd;
                    this.pageTitleService.setTitle(
                        `${this.PAGE_TITLE} - ${this.cwd.name}`
                    );
                }
                if (data.error) {
                    if (data.error.code == 8018) {
                        // this.openState = 2; // this is a user requiring password lock
                    }
                    this.log.error(`Link file list received Error: ${data.error.code}: ${data.error.msg}`);
                }
                this.passlock = data.passwordlock;
                if (data.loaded && data.sorted) {
                    if (
                        data.pathlist.length == 1 &&
                        data.pathlist[0].sync_id == data.cwd.sync_id
                    ) {
                        this.activate(data.pathlist[0], true);
                    } else if (data.upload != this.UPLOAD_NON_VISIBLE) {
                        this.list = data.pathlist;
                        this.paginate.total = this.list.length;
                        this.paginate.numPages = Math.ceil(
                            this.list.length / this.paginate.itemsPerPage
                        );
                        this.paginate.currentPage =
                            parseInt(this.route.snapshot.queryParams['page'], 10) || 1;

                        if (
                            this.route.snapshot.queryParams['page'] &&
                            parseInt(this.route.snapshot.queryParams['page'], 10) <=
                                this.paginate.numPages
                        ) {
                            this.onPageChange(
                                parseInt(this.route.snapshot.queryParams['page'], 10)
                            );
                        } else {
                            this.onPageChange(1);
                        }
                    }
                    //white label attributes
                    if (data.image_cachekey) {
                        this.isWhiteLabel = true;
                        this.linkTextColor = data.link_text_color;
                    } else {
                        this.isWhiteLabel = false;
                        this.linkTextColor = '#00adef';
                    }
                    //comment feature
                    this.allowComment = data.allow_comment;
                    this.initialized = true;
                }
            });
    }

    public ngOnDestroy() {
        this.router.routeReuseStrategy.shouldReuseRoute = this.prevRouterState;
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    openUploadFolderModal() {
        this.uploadFolderService.showFolderUpload();
    }

    public changeDir(id: number, rmState = false) {
        const params =
            rmState == true
                ? { page: undefined, sync_id: id }
                : { sync_id: id };

        this.store.dispatch(new LinkFileListActions.ChangeDirAction(id));
        this.router.navigate([], {
            relativeTo: this.route,
            ...this.decorateFragment(),
            queryParams: { sync_id: id }
        });
    }

    public onDragEnd($event) {
        $event.preventDefault();
        $event.dataTransfer.effectAllowed = 'none';
        $event.dataTransfer.dropEffect = 'none';
        return false;
    }
    public onDragOver($event) {
        $event.preventDefault();
        return false;
    }
    public onDrop($event) {
        $event.preventDefault();
        const list = $event.dataTransfer.items;

        if (list && list.length > 0) {
            if (this.browserSupport.testDirUpload()) {
                let hasDirs = false;
                let items: Entry[] = [];
                for (let i = 0, len = list.length; i < len; i++) {
                    const item: Entry = list[i].webkitGetAsEntry();
                    if (item) {
                        items.push(item);
                        if (!hasDirs && item.isDirectory) {
                            hasDirs = true;
                        }
                    }
                }
                if (hasDirs) {
                    this.uploadFolderService.run(this.cwd, items, this.cwd.linkID);
                } else {
                    items = [];
                    this.transferService.queuePublicUpload($event.dataTransfer.files);
                }
            } else {
                // browser does not support dir upload
                this.transferService.queuePublicUpload($event.dataTransfer.files);
            }
        } else if ($event.dataTransfer.files.length) {
            this.transferService.queuePublicUpload($event.dataTransfer.files);
        } else {
            this.log.info('No files were dropped for upload');
        }
        return false;
    }

    public showDownloadAll() {
        return (
            this.initialized &&
            !this.previewonly &&
            this.compat == 1 &&
            this.upload != this.UPLOAD_NON_VISIBLE &&
            // && !this.errcode
            this.list.length > 0
        );
    }

    public showfileTransferModal() {
        this.transferService.showTransfer();
    }

    isTransferComplete() {
        if (this.buildTransferItemService.view.isUpload) {
            this.isTransfering = true;
        } else if (!this.buildTransferItemService.view.isUpload && this.isTransfering && this.upload == 2) {
            this.isTransfering = true;
            return true;
        }
        return false;
    }

    public downloadZipFile() {
        const ref = this.modalService.open(DialogLinkZipComponent, {
            backdropClass: 'in',
            windowClass: 'in',
            backdrop: 'static',
        });
        this.blendService.track(BlendEvent.DOWNLOAD_AS_ZIP, {});
        ref.componentInstance.linkID = this.route.snapshot.params['cachekey'];
        ref.componentInstance.linkpassword = this.passlock;
    }

    public activate(item, replace = false) {
        if (item.type == 'dir') {
            this.changeDir(item.id);
        } else {
            // console.log('Activate ' , item);
            let opts;

            if (replace) {
                opts = { location: 'replace' };
            }
            const type = this.getItemType(item);

            // don't overwrite sync_id as it needs to be passed in
            // so that <sync-header-previews> can have a proper back
            // button.
            if (this.router.url.includes('/dl')) {
                const navigationParams = ['/dl', this.route.snapshot.params['cachekey'], 'view', type, item.id];
                // add key in navigation params array if it exists in router params, otherwise key after # in fragment will be used
                if (this.route.snapshot.params['key']) { navigationParams.splice(2, 0, this.route.snapshot.params['key']); }
                this.router.navigate(navigationParams, {
                    ...this.decorateQueryParams(),
                    ...this.decorateFragment()
                });
            } else if (this.router.url.includes('/al')) {
                this.router.navigate(['al', this.route.snapshot.params['cachekey'], 'view', type, item.id
                ], this.decorateFragment());
            }
        }
    }

    private getItemType(item) {
        if (this.fileItemService.isImage(item)) { return 'image'; }
        if (this.fileItemService.isText(item)) { return 'text'; }

        if (!this.compat) { return 'default'; }

        if (this.fileItemService.isPDF(item)) {
            if (item.size > this.fileItemService.MAX_PREVIEW_SIZE_PDF && item.previewonly && !this.isBusiness) {
                return 'pdf';
            } else if (item.size <= this.fileItemService.MAX_PREVIEW_SIZE_PDF || this.isBusiness) {
                return 'doc';
            }
        } else if (this.isBusiness && this.fileItemService.isDocument(item)) {
            return 'doc';
        }

        return 'default';
    }

    /**
     * Downloads a specific file
     * @param  {Object} item The pathitem object
     * @return {Promise}
     */
    public async downloadFile(item: sync.IFile) {
        if (this.compat) {
            if (item.context == 'applink') {
                const url = item.compaturl;
                window.location.href = url;
            } else {
                const url = await this.buildTransferItemService.getCompatUrl(
                    item,
                    this.buildTransferItemService.ACT_DOWNLOAD
                );
                window.location.href = url;
            }
        } else {
            await this.transferService.queuePublicDownload([item]);
            this.transferService.showTransfer();
        }
    }

    public async openFile(item: sync.IFile) {
        if (item.context == 'applink') {
            const url = item.compaturl;
            window.location.href = url;
        } else if (item.context == 'link' && this.fileItemService.isStreamable(item.kind)) {
            this.activate(item);
        } else {
            const url = await this.buildTransferItemService.getCompatUrl(
                item,
                this.buildTransferItemService.ACT_PREVIEW
            );
            window.location.href = url;
        }
    }

    public isOpenable(item: sync.IFile) {
        if (item.context == 'link' && (item.previewonly == 8 || !this.compat)) {
            return false;
        }
        if (
            item.context == 'link' &&
            getFileExt(item.name) == 'pdf' &&
            !item.link_is_business
        ) {
            return false;
        }
        if (this.isMSOffice(item)) {
            return false;
        }

        if (!canBrowserOpen(item.name)) {
            return false;
        }
        if (item.context == 'link' && this.fileItemService.isStreamable(item.kind)) {
            return false;
        }
        return true;
    }

    public isPreviewable(item: sync.IFile) {
        if (!this.compat && (this.fileItemService.isImage(item) || this.fileItemService.isText(item))) {
            return true;
        }
        if (this.compat &&
            (!item.transferitem &&
                item.filetype.viewable ||
                this.fileItemService.isStreamable(item.kind)
            )
        ) {
            return true;
        }
        return false;
    }

    public isMSOffice(item: sync.IFile) {
        const app = this.fileItemService.getMSOfficeApp(item);
        if (app === 'None') {
            return false;
        }
        return true;
    }

    public onPageChange(page) {
        this.paginate.currentPage = page;
        this.paginate.viewOffset = this.paginate.itemsPerPage * (page - 1);
        this.paginate.viewEnd =
            this.paginate.itemsPerPage + this.paginate.viewOffset;
        const pageParam =
            this.paginate.currentPage > 1
                ? this.paginate.currentPage
                : undefined;
        this.router.navigate([], {
            relativeTo: this.route,
            ...this.decorateFragment(),
            queryParams: { page: pageParam },
            queryParamsHandling: 'merge'
        });
        this.thumbs.getThumbs(this.list, this.paginate);
    }
    private decorateQueryParams() {
        if (this.route.snapshot.queryParams['sync_id']) {
            return { queryParams: { sync_id: this.route.snapshot.queryParams['sync_id'] } };
        }
    }
    private decorateFragment() {
        if (!this.compat || this.route.snapshot.fragment) {
            return { fragment : this.route.snapshot.fragment };
        }
    }

    /**
     * this function updates css variables based on changes of this component's attributes
     */
    @HostBinding('attr.style')
    public get customColorsCss(): any {
        return this.sanitizer.bypassSecurityTrustStyle(
            `--linkTextColor: ${this.linkTextColor};`
        );
    }
}
